<template>
  <div>
    <CommonDialog
      :dialog="moduleActivationDialog"
      :head-text="$t('projects.module-activate-title')"
      :content-text="$t('projects.module-activate-dialog')"
      :confirm-button="{
        text: $t('projects.module-activate-confirm'),
        icon: 'mdi-cash-check'
      }"
      :on-confirm="activatePreselectedModule"
      :on-cancel="() => (moduleActivationDialog = false)"
    ></CommonDialog>
    <CommonTable
      :list-array="list"
      :headers="headers"
      :slots="slots"
      :actions="actions"
    >
    </CommonTable>
  </div>
</template>

<script>
import CommonTable from "../common/tables/CommonTable";
import CommonDialog from "../common/dialogs/CommonDialog";
export default {
  name: "ModulesProject",
  props: ["id"],
  components: { CommonDialog, CommonTable },
  data: function() {
    return {
      preselectedModuleId: null,
      moduleActivationDialog: false,
      actions: [
        {
          type: "icon",
          icon: "mdi-led-on",
          text: "activate",
          onClickMode: "callback",
          callback: item => {
            this.showModuleActivationDialog(item.id);
          },
          showFunction: item => {
            return !item.isActive;
          }
        },
        {
          type: "icon",
          icon: "mdi-led-outline",
          text: "deactivate",
          onClickMode: "callback",
          callback: item => {
            this.deactivate(item.id);
          },
          showFunction: item => {
            return item.isActive;
          }
        }
      ],
      slots: [
        {
          name: "price-text",
          type: "projects-module-price"
        }
      ],
      headers: [
        {
          text: this.$t("projects.module"),
          align: "left",
          value: "name",
          sortable: false
        },
        /** Disable Column as pricing is new done by Enertech
        {
          text: this.$t("projects.base-price"),
          value: "price-text",
          sortable: false
        },
         */
        {
          text: this.$t("projects.status"),
          value: "status-text",
          sortable: false
        },
        {
          text: this.$t("sources.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ]
    };
  },
  methods: {
    showModuleActivationDialog(id) {
      this.preselectedModuleId = id;
      this.moduleActivationDialog = true;
    },
    activatePreselectedModule() {
      this.moduleActivationDialog = false;
      if (this.preselectedModuleId === null) {
        return;
      }
      this.$store
        .dispatch("pricingOtherStore/moduleStore/activate", {
          params: {
            ids: [this.preselectedModuleId],
            project_id: this.$route.params.id
          }
        })
        .then(() => this.getList());
    },
    deactivate(id) {
      this.$store
        .dispatch("pricingOtherStore/moduleStore/deactivate", {
          params: {
            ids: [id],
            project_id: this.$route.params.id
          }
        })
        .then(() => this.getList());
    },
    getList() {
      this.$store.dispatch("pricingOtherStore/moduleStore/getList", {
        params: {
          project_id: this.$route.params.id
        }
      });
    }
  },
  computed: {
    project() {
      return this.$store.getters["projectStore/getItem"];
    },
    /** Disable Column as pricing is new done by Enertech
    prices() {
      return this.$store.getters["pricingStore/getPrices"] || {};
    },
   */
    list() {
      let formData = (field, item) =>
        (item[field] && `(${this.$dateTime(item[field], "short")})`) || "";
      return this.$store.getters["pricingOtherStore/moduleStore/getList"].map(
        item => ({
          ...item,
          ["status-text"]: item["isActive"]
            ? `${this.$t("projects.active")} ${formData("activated_at", item)}`
            : `${this.$t("projects.inactive")} ${formData(
                "deactivated_at",
                item
              )}`
          /** Disable Column as pricing is new done by Enertech
          ["price-text"]: `${item.base_price} ${
            this.project.currency
          }/${this.$t("projects.year")}/${this.$t("projects.datapoint")}`*/
        })
      );
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
